import styled from 'styled-components';

import {body14Bold} from '~/shared/theme/typography';
import {useAsyncSanitizeHtml} from '~/shared/utils/sanitizeHtml';
import CircleInfoIcon from '~/assets/images/icons/circle-info.svg?react';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {Title} from '~/shared/components/UserTransactions/shared';

const StyledInfoIcon = styled(CircleInfoIcon).attrs({
  viewBox: '0 0 18 18',
})`
  width: 15px;
  height: 15px;
  min-width: 15px;
  min-height: 15px;
  margin-top: 6px;

  path {
    fill: ${({theme}) => theme.colors.contentInteractiveSubdued};
  }

  ${flipOnLTR`
    margin-left: 10px;
  `}
`;

const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const CompanyAnnouncementRoot = styled(Title)`
  color: ${({theme}) => theme.colors.contentInteractiveSubdued};
  ${body14Bold};
  margin-right: 0;
  margin-top: 0;

  a {
    color: ${({theme}) => theme.colors.contentLink};
  }
`;

const CompanyAnnouncement = ({companyAnnouncement}: {companyAnnouncement: string}) => {
  const sanitizedCompanyAnnouncement = useAsyncSanitizeHtml(companyAnnouncement);

  return (
    <Wrap>
      <StyledInfoIcon/>
      <CompanyAnnouncementRoot dangerouslySetInnerHTML={{__html: sanitizedCompanyAnnouncement}} />
    </Wrap>
  );
};

export default CompanyAnnouncement;
